import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import userService from "../../services/userService";
import authService from "../../services/authService";
import { connect, useSelector } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.actions";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Chip,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PeopleIcon from "@mui/icons-material/People";
import paymentServices from "../../services/paymentServices";
import { toast, ToastContainer } from "react-toastify";

function PriceTag({
  price_detail,
  planPeriod,
  planName,
  planList,
  plan_mode,
  price_size = "50px",
  bg_color = "bg-gray",
  hide,
  history,
  currentUser,
  hide_mode,
  plan_id,
  defaultPlan,
  setCurrentPlan,
  setCurrentplancheck,
}) {
  let detail = { price: null, user_count: null, period: null, plan_mode: null };
  const [details, setdetails] = useState(detail);
  const [user_count_list, setuser_count] = useState([]);
  let [plan_period, setplan_period] = useState(planPeriod);
  const [location, setLocation] = useState(useLocation());
  const userDetails = useSelector((user) => user);

  useEffect(() => {
    setplan_period(planPeriod);
    plan_period = planPeriod;
    initialCall();
  }, [planPeriod]);

  const initialCall = () => {
    let time_period = Object.keys(price_detail);
    if (!plan_period) {
      let first_plan_period = time_period[0];
      let { price, user_count } = price_detail[first_plan_period][0];
      setdetails({ price, user_count, period: first_plan_period });
      setuser_count(price_detail[first_plan_period]);
      setplan_period(first_plan_period);
    } else {
      let { price, user_count } = price_detail[plan_period][0];
      setdetails({ price, user_count, period: plan_period });
      setuser_count(price_detail[plan_period]);
    }
  };

  const dropOnChange = (count) => {
    let arr = price_detail[plan_period];
    let findObj = arr.find((obj) => obj.user_count == count);
    const { price, user_count } = findObj;
    setdetails({ price, user_count, period: plan_period });
  };

  const buyPlan = () => {
    let data = details;
    data.planName = planName;
    data["plan_id"] = plan_id;
    data.plan_mode = plan_mode.mode;
    const user = authService.getCurrentUser();

    const redirectToDashboard = () => {
      history.push("/dashboard");
    };

    if (
      currentUser.planName !== data.planName &&
      currentUser.planName !== "PET Basic Plan"
    ) {
      Swal.fire({
        title: `${currentUser.planName} features will no longer exist with ${data.planName}`,
        type: "warning",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Okay!",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.value === true) {
          if (user) {
            // history.push({
            //   pathname: `/payment`,
            //   state: { data: data },
            // });
            const updateDetails = {
              planId: plan_id,
              planName: planName,
              userEmail: userDetails.user?.currentUser?.email,
              duration: data.period,
            };
            console.log("updateDetails", updateDetails, data, userDetails.user);
            const updateDet = await paymentServices.UpdateSubs(updateDetails);
            console.log("updateDet", updateDet);
            setCurrentplancheck(true);
            // setCurrentPlan(updateDet.user.plan.name)
            if (updateDet.status === 200) {
              toast.success("Updated Successfully");
              redirectToDashboard();
            } else {
              toast.warn("Update Failed");
            }
          } else {
            history.push({
              pathname: "/login",
            });
          }
        }
      });
    } else {
      if (user) {
        history.push({
          pathname: `/payment`,
          state: { data: data },
        });
      } else {
        history.push({
          pathname: "/login",
        });
      }
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%", // Takes full height from parent
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        overflow: "hidden",
        background: "linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%)",
        border: "1px solid #e0e0e0",
      }}
    >
      {defaultPlan ? (
        <Box
          sx={{
            p: 3,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <AttachMoneyIcon sx={{ fontSize: 40, color: "#4caf50" }} />
              <Typography
                variant="h2"
                sx={{ fontWeight: 700, color: "#4caf50" }}
              >
                0
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: "text.secondary", alignSelf: "flex-end", mb: 1 }}
              >
                /Month
              </Typography>
            </Box>
          </Box>
          <Chip
            label="Free Version"
            color="success"
            sx={{
              fontWeight: 700,
              fontSize: "16px",
              py: 2.5,
              borderRadius: 2,
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {(location.pathname === "/pricedetails" ||
            location.pathname === "/homepricedetails") && (
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                py: 2,
                fontWeight: 600,
                bgcolor: "primary.main",
                color: "white",
              }}
            >
              {planName}
            </Typography>
          )}

          <Box
            sx={{ p: 3, flexGrow: 1, display: "flex", flexDirection: "column" }}
          >
            {/* Price Display - Fixed height */}
            <Box sx={{ minHeight: "120px", textAlign: "center", mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AttachMoneyIcon
                  sx={{ fontSize: 28, color: "primary.main", mb: 1 }}
                />
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    color: "primary.main",
                    fontSize: price_size,
                  }}
                >
                  {details.price}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: "text.secondary", alignSelf: "flex-end", mb: 2 }}
                >
                  /{details.period && details.period.slice(0, -2)}
                </Typography>
              </Box>
            </Box>

            {/* User Count Selector - Fixed height */}
            <Box
              sx={{
                minHeight:
                  plan_mode.mode === "Team" && user_count_list.length >= 1
                    ? "80px"
                    : "0px",
                mb: 2,
              }}
            >
              {plan_mode.mode === "Team" && user_count_list.length >= 1 && (
                <FormControl fullWidth size="small">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <PeopleIcon
                      sx={{ fontSize: 20, color: "text.secondary" }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "text.secondary" }}
                    >
                      User count
                    </Typography>
                  </Box>
                  <Select
                    defaultValue={user_count_list[0]?.user_count}
                    onChange={(e) => dropOnChange(e.target.value)}
                    sx={{ borderRadius: 2 }}
                  >
                    {user_count_list.map((obj) => (
                      <MenuItem value={obj.user_count} key={obj.price}>
                        {obj.user_count} users
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>

            {/* Plan Details - Fixed height with scroll */}
            {planList && (
              <Box
                sx={{
                  height: "140px", // Fixed height
                  overflowY: "auto",
                  mb: 2,
                  p: 2,
                  bgcolor: "#f5f5f5",
                  borderRadius: 2,
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: "3px",
                  },
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ "& ul": { pl: 2, m: 0 }, "& li": { mb: 0.5 } }}
                >
                  {planList}
                </Typography>
              </Box>
            )}

            {/* Subscribe Button - Fixed at bottom */}
            {details.price > 0 && (
              <Box sx={{ mt: "auto" }}>
                {hide === true || hide_mode === true ? (
                  <Button
                    component={Link}
                    to="/login"
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: 3,
                      textTransform: "none",
                      py: 1.5,
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                  >
                    SIGN IN
                  </Button>
                ) : (
                  <>
                    {!currentUser?.isAdmin && (
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={buyPlan}
                        sx={{
                          borderRadius: 3,
                          textTransform: "none",
                          py: 1.5,
                          fontWeight: 600,
                          fontSize: "16px",
                          background:
                            "linear-gradient(45deg, #667eea 30%, #764ba2 90%)",
                          "&:hover": {
                            background:
                              "linear-gradient(45deg, #764ba2 30%, #667eea 90%)",
                          },
                        }}
                      >
                        {currentUser?.planName === planName
                          ? "Resubscribe"
                          : "Subscribe"}
                      </Button>
                    )}
                  </>
                )}
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PriceTag));
